module.exports = __webpack_public_path__ + "images/35f4c2392cdfd1344fce2cbc6d632df7.svg";


//////////////////
// WEBPACK FOOTER
// ../public/images/saucey.svg
// module id = 174
// module chunks = 0